(function () {
  'use strict';

  var alertFastTimeout = 1000;
  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/data/log', {
      templateUrl: 'modules/app/data/log/log.html',
      controller: 'ErrorLogCtrl',
      requiredPermissions: ['admin']
    });
  }]).
  /**
   * Error/Archived Error Viewer
   */
  controller('ErrorLogCtrl', ['$filter', '$q', '$routeParams', '$scope', '$timeout', 'Alerts', 'Api', 'ApiErrors', 'ConfirmModal', 'wsEventNames', function ($filter, $q, $routeParams, $scope, $timeout, Alerts, Api, ApiErrors, ConfirmModal, wsEventNames) {
    $scope.section = "log";
    var archived = $routeParams.archived === 'true';
    $scope.archived = archived;

    // errors model
    $scope.errors = {
      archived: archived,
      count: null,
      data: null,
      dtPickerInput: {
        error: {
          since: false,
          until: false
        },
        value: {
          since: null,
          until: null
        }
      },
      dtPickerOptions: {
        'constrainInput': true,
        'dateFormat': 'yy-mm-dd',
        'separator': 'T',
        'timeFormat': 'HH:mm:ss.l',
        'timeSuffix': 'Z',
        'showSecond': true,
        'showMillisec': true
      },
      getCountLabel: function getCountLabel() {
        if (this.count === null) {
          return 'Loading...';
        }
        return this.count + (this.searchApplied ? ' matching' : this.archived ? ' archived' : '') + (this.count === 1 ? ' error' : ' errors');
      },
      page: 1,
      saving: true,
      searchApplied: false
    };

    // search model
    $scope.search = {
      text: null,
      since: null,
      until: null
    };
    $scope.loading = false;
    $scope.fetchPage = function fetchPage(offset, limit) {
      offset = offset || 0;
      limit = limit || 10;
      $scope.loading = true;
      var search = $scope.search,
        params = {
          archived: archived,
          search: search.text,
          since: search.since,
          until: search.until,
          _limit: limit,
          _offset: offset,
          order_by: '-captured'
        };
      var searchText = search.text;
      return ApiErrors.list(params).then(function (result) {
        $scope.errors.count = result.count;
        $scope.errors.data = _(result.results).map(function (error) {
          // attempt to parse JSON statement data
          if (!_.isUndefined(error.requestContent)) {
            try {
              error.requestContent = JSON.stringify(JSON.parse(error.requestContent), null, 4);
            } catch (e) {
              error.requestContent = "Unable to parse the following JSON:\n" + error.requestContent + "\n ";
              error.requestContent = error.requestContent.replaceAll("javascript", "");
            }
          }

          // format timestamp
          var parts = error.captured.split('T');
          error.capturedDate = $filter('date')(parts[0], 'dd MMM yyyy');
          error.capturedTime = parts[1];
          error.capturedTime = error.capturedTime.replace('Z', ' UTC');

          // check for undefined/null sender info
          error.sender = error.senderName || error.senderEmail ? (error.senderName || 'N/A') + " [" + (error.senderEmail || 'N/A') + "]" : null;

          // parse headers
          if (!_.isUndefined(error.headers)) {
            try {
              error.headers = _(JSON.parse(error.headers)).map(function (value, key) {
                return {
                  name: key,
                  value: value
                };
              });
            } catch (e) {
              error.headers = "Error parsing header info!";
            }
          }

          // create error "row" object
          var hiddenMatch = hiddenContentHasMatch(error, searchText);
          return {
            expand: hiddenMatch,
            saving: false,
            error: error
          };
        });
        $scope.errors.page = Math.ceil(offset / limit) + 1;
        $scope.errors.saving = false;
        $scope.fetchError = null;
        $scope.hasData = true;
        $scope.loading = false;
        return result;
      }, function (error) {
        $scope.errors.saving = false;
        $scope.fetchError = error.data.message;
        $scope.hasData = false;
        $scope.loading = false;
      });
    };

    // search hidden error content for text match
    function hiddenContentHasMatch(error, searchText) {
      if (!searchText) {
        return false;
      }
      var st = searchText.toLowerCase();
      return error.headers && _(error.headers).any(function (header) {
        return header.name.toLowerCase().includes(st) || header.value.toLowerCase().includes(st);
      }) || error.requestContent && error.requestContent.toLowerCase().includes(st) || error.requestMethod && error.requestMethod.toLowerCase().includes(st) || error.requestVersion && error.requestVersion.toLowerCase().includes(st) || error.sender && error.sender.toLowerCase().includes(st) || error.statusCode && error.statusCode.toString().toLowerCase().includes(st);
    }

    // update archived flag in db for this error
    function setArchiveState(row, newArchiveState) {
      row.saving = true;
      $scope.errors.saving = true;
      return ApiErrors.saveArchiveState(row.error.id, newArchiveState).then(function () {
        Alerts.raiseAlert({
          text: newArchiveState ? "Archive successful" : "Unarchive successful",
          type: "success",
          autoDismissTimeout: alertFastTimeout
        });
        updateData($scope.errors.page);
      }, function (error) {
        row.saving = false;
        $scope.errors.saving = false;
        Alerts.raiseAlert({
          type: 'danger',
          text: error.data.message
        });
        return $q.reject(error);
      });
    }
    $scope.archiveAll = function archiveAll() {
      if ($scope.errors.saving) {
        return;
      }
      $scope.errors.saving = true;
      var modal = {
        title: 'Archive all errors',
        subtitle: 'Confirm that you want to move all ' + $scope.errors.count + ' errors to "Archived errors".',
        body: 'This action cannot be undone.\n\n' + 'Individual errors can be moved back from "Archived errors", ' + 'but the set errors affected by this action cannot be restored as a set.\n\n' + 'Are you sure you want to complete this action?',
        confirmBtn: 'Confirm',
        confirm: function confirm() {
          ApiErrors.archiveAll().then(function (result) {
            Alerts.raiseAlert({
              text: result + " errors successfully moved to 'Archived errors'.",
              type: "success"
            });
            updateData($scope.errors.page);
          }, function (error) {
            $scope.errors.saving = false;
            Alerts.raiseAlert({
              type: 'danger',
              text: error.data.message
            });
            return $q.reject(error);
          });
        },
        cancel: function cancel() {
          $scope.errors.saving = false;
        }
      };
      ConfirmModal.open($scope, modal);
    };

    // check if row is "expanded" and return appropriate css class name
    $scope.getRowState = function getRowState(row) {
      return row.expand ? 'expand-open' : 'expand-closed';
    };
    $scope.toggleDatepicker = function toggleDatepicker(dpName) {
      var dpElement = $('#' + dpName),
        widget = dpElement.datepicker('widget');
      dpElement.datepicker(widget.is(':visible') ? 'hide' : 'show');
    };
    $scope.expandRow = function (row) {
      row.expand = !row.expand;
    };
    $scope.toggleArchiveState = function (row) {
      if ($scope.errors.saving || row.saving) {
        return;
      }
      var toArchive = !$scope.errors.archived;
      setArchiveState(row, toArchive);
    };

    // watch dtPickerInput values for change, validate & apply
    var applyDtPickerValues = _.debounce(function () {
      validateDtPickerInput();
    }, 500);
    $scope.$watchCollection('errors.dtPickerInput.value', function (newInputs, oldInputs) {
      if (!angular.equals(newInputs, oldInputs)) {
        applyDtPickerValues();
      }
    });

    // validate & apply each timestamp entered manually or through dtPicker
    function validateDtPickerInput() {
      var dtInput = $scope.errors.dtPickerInput;
      var updateNeeded = false;
      _.each(_.keys(dtInput.value), function (key) {
        var prevError = dtInput.error[key];
        var inputValue = dtInput.value[key];
        var dtValue = validateTimestamp(inputValue);
        // check for invalid input
        dtInput.error[key] = dtValue === null && !_.isEmpty(inputValue);
        updateNeeded = updateNeeded || prevError !== dtInput.error[key];
        // check for change in dtValue
        updateNeeded = updateNeeded || !angular.equals($scope.search[key], dtValue);
        $scope.search[key] = dtValue;
      });
      if (updateNeeded) {
        updateData();
      }
    }

    // returns the ISO format of a valid timestamp, or null if invalid
    function validateTimestamp(value) {
      if (value === null || typeof value === 'undefined') {
        return null;
      }
      var dt = moment.utc(value);
      if (!dt.isValid()) {
        return null;
      }
      return dt.toISOString();
    }

    // watch search values for change & update date
    var applySearch = _.debounce(function () {
      updateData();
    }, 1000);
    $scope.$watchCollection('search', function (newValue, oldValue) {
      if (!angular.equals(newValue, oldValue)) {
        applySearch();
      }
    });

    // update data using search values
    function updateData(page) {
      page = page || 1;
      var search = $scope.search;
      $scope.errors.searchApplied = search.text !== null && search.text !== "" || search.since !== null && search.since !== "" || search.until !== null && search.until !== "";
      $scope.$broadcast(wsEventNames.pager.setPage, page);
    }

    // fire off event that will trigger initial fetchPage
    $timeout(function () {
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    }, 10);
  }]);
})();
